import styled from 'styled-components';

export const SimpleDivider = styled.hr`
  flex-grow: 1;
  border: none;
  border-top: ${(props) => `1px solid ${props.theme.colors.primary.ltGrey1}`};
  margin: 0.5rem 0;
`;
